<!--
  ~ /**
  ~   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~   ~  * No part of this publication may be reproduced, distributed,
  ~   ~  * or transmitted in any form or by any means, including photocopying, recording,
  ~   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~   ~  * except in the case of brief quotations embodied in critical
  ~   ~  * reviews and certain other noncommercial uses permitted by copyright law.
  ~   ~  * AUTHOR : bs
  ~   ~  * DATE : 29/04/2025 17:42
  ~ **/
  -->

<div class="action">
  <button class="action">
    <i
      class="fal fa-{{ action().icon }}"
      [style.color]="action().iconColor || black()"
    ></i>
  </button>
  <ul class="dropdown">
    @for (subAction of action().items; track subAction.name) {
      <li (click)="onClickSubAction(subAction)">
        <div class="icon">
          <i
            class="fal fa-{{ subAction.icon }}"
            [style.color]="subAction.iconColor"
          ></i>
        </div>
        <div class="text">
          {{ subAction.text | translate }}
        </div>
      </li>
    }
  </ul>
</div>
